import { useColorModeValue } from '@chakra-ui/react'
import { useMemo } from 'react'
import {
  TRw1ColorNamespace,
  TColorIndexKey,
  TColorNameKey,
  BodyBackgroundNuance,
} from './theme'

type TNuance = BodyBackgroundNuance | TColorIndexKey | TColorNameKey

type TDistinctNuances = {
  dark: TNuance
  light: TNuance
}

export type TuseColorArgs = {
  nuance: TDistinctNuances | TNuance
  palette: keyof TRw1ColorNamespace
}

/**
 * useColorMode hook.
 *
 * Takes a `nuance` and a `palette` based on the theme.
 *
 * The `nuance` can be a string - in most cases - or a record of `light`
 * and `dark` distinct values.
 */
export const useColor = ({ nuance, palette }: TuseColorArgs): string => {
  const isHighlight = useMemo(() => palette === 'highlight', [palette])

  const isDistinct = useMemo(() => nuance instanceof Object, [nuance])

  const color = useColorModeValue(
    `rw1.${palette}${isHighlight ? '' : '.light'}.${isDistinct ? (nuance as TDistinctNuances).light : nuance
    }`,
    `rw1.${palette}${isHighlight ? '' : '.dark'}.${isDistinct ? (nuance as TDistinctNuances).dark : nuance
    }`,
  )

  return color
}
